class LoadingState {
  options;

  hostedFieldsLoadingProgress = {
    totalCount: 0,
    loaded: 0,
    addCount() {
      this.totalCount += 1;
    },
    loadComplete() {
      this.loaded += 1;
    },
    inProgress() {
      return this.totalCount !== this.loaded;
    }
  };

  constructor(options) {
    this.options = options;
  }

  notifyLoadingListener() {
    const isLoading = this.hostedFieldsLoadingProgress.inProgress();
    if (this.options.isLoading) {
      this.options.isLoading(isLoading);
    }
  }

  addHostedFieldCount() {
    this.hostedFieldsLoadingProgress.addCount();
  }

  notifyHostedFieldLoadComplete() {
    this.hostedFieldsLoadingProgress.loadComplete();
    this.notifyLoadingListener();
  }

  clearState() {
    this.hostedFieldsLoadingProgress.totalCount = 0;
    this.hostedFieldsLoadingProgress.loaded = 0;
  }
}

export default LoadingState;
